var _circle, _circle2, _circle3, _circle4, _circle5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgLazyLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "lds-balls",
    width: "80px",
    height: "80px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.8023,
    cy: 59.9068,
    r: 6,
    fill: "#51CACC"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "75;57.72542485937369",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "50;73.77641290737884",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#51CACC;#9DF871",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.0792,
    cy: 69.9923,
    r: 6,
    fill: "#9DF871"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "57.72542485937369;29.774575140626318",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "73.77641290737884;64.69463130731182",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#9DF871;#E0FF77",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.7746,
    cy: 52.4491,
    r: 6,
    fill: "#E0FF77"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "29.774575140626318;29.774575140626315",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "64.69463130731182;35.30536869268818",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#E0FF77;#DE9DD6",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.4208,
    cy: 31.5213,
    r: 6,
    fill: "#DE9DD6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "29.774575140626315;57.72542485937368",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "35.30536869268818;26.22358709262116",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#DE9DD6;#FF708E",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.9232,
    cy: 36.1304,
    r: 6,
    fill: "#FF708E"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "57.72542485937368;75",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "26.22358709262116;49.99999999999999",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#FF708E;#51CACC",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLazyLoading);
export default __webpack_public_path__ + "static/media/img-lazy-loading.a033b690ec34db240c6a62bff2bcc533.svg";
export { ForwardRef as ReactComponent };